import { Accordion, Container } from "@peracto/peracto-blocks-tailwind";

import Carousel from "./Carousel";
import InfoPanels from "./InfoPanels";
import Products from "./Products";
import MenuItemsCarousel from "./MenuItemsCarousel";

export default {
    plugins: {
        content: [Carousel, Accordion, InfoPanels, Products, MenuItemsCarousel],
        layout: [Container],
    },
};
